export function createSurveyAppEventParams(actionParams, surveyUnitLabel, entryId) {
    return (Object.assign(Object.assign({}, actionParams), { SurveyUnitLabel: surveyUnitLabel, entryId }));
}
